import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Header from "./components/Header";
import Feature1 from "./components/features/Feature1";
import Feature2 from "./components/features/Feature2";
import Feature3 from "./components/features/Feature3";
import Feature4 from "./components/features/Feature4";
import Feature5 from "./components/features/Feature5";
import Feature6 from "./components/features/Feature6";
import Feature7 from "./components/features/Feature7";
import Feature8 from "./components/features/Feature8";
import Feature9 from "./components/features/Feature9";
import { Slide, ToastContainer } from "react-toastify";
import Blogs from "./components/sub-components/Blogs";
import AboutUS from "./components/sub-components/AboutUs";
import Management from "./components/sub-components/Management";
import ScrollToTop from "./components/sub-components/ScrollToTop";
import { CountryProvider } from "./context/CountryContext";
import TestModeBadge from "./components/TestModeBadge";

const { PUBLIC_URL } = process.env;

function App() {
  return (
    <CountryProvider>
    <BrowserRouter>
      <ScrollToTop /> 
      <div className="flex flex-col min-h-screen bg-[#0b1623] overflow-x-hidden">
        <ToastContainer transition={Slide} />
        <Header />

        {/* MAIN CONTENT */}
        <main className="flex-grow bg-[#0b1623] overflow-x-hidden">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/SkillsAndKnowledgeAssessment"
              element={<Feature1 />}
            />
            <Route path="/Reporting" element={<Feature2 />} />
            <Route path="/AI" element={<Feature3 />} />
            <Route path="/Customization" element={<Feature4 />} />
            <Route path="/Feedback" element={<Feature5 />} />
            <Route path="/Proctoring" element={<Feature6 />} />
            <Route path="/Security" element={<Feature7 />} />
            <Route path="/SelfGrading" element={<Feature8 />} />
            <Route path="/Certificates" element={<Feature9 />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/about-us" element={<AboutUS />} />
            <Route path="/management" element={<Management />} />
          </Routes>
        </main>

        {/* FOOTER */}
        <Footer />
        <TestModeBadge />
      </div>
    </BrowserRouter>
    </CountryProvider>
  );
}

export default App;
